var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "file-row__container" },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col" }, [
          _c("span", { staticClass: "file-row__label" }, [
            _vm._v("Nombre del Documento:")
          ]),
          _c("br"),
          _c("span", [_vm._v(_vm._s(_vm.documentName))])
        ]),
        _c("div", { staticClass: "col" }, [
          _c("span", { staticClass: "file-row__label" }, [_vm._v("Archivo:")]),
          _c("br"),
          _c("span", [_vm._v(_vm._s(_vm.documentFileName))])
        ]),
        _vm.isProvisionalRemedyArea
          ? _c("div", { staticClass: "col" }, [
              _c("span", { staticClass: "file-row__label" }, [
                _vm._v(" Nombre del Evaluador: ")
              ]),
              _c("br"),
              _c("span", [_vm._v(_vm._s(_vm._f("empty")(_vm.evaluatorName)))])
            ])
          : _vm._e(),
        _vm.isProvisionalRemedyArea
          ? _c("div", { staticClass: "col" }, [
              _c("span", { staticClass: "file-row__label" }, [
                _vm._v(" Usuario: ")
              ]),
              _c("br"),
              _c("span", [_vm._v(_vm._s(_vm._f("empty")(_vm.createdBy)))])
            ])
          : _vm._e(),
        _vm.isProvisionalRemedyArea
          ? _c("div", { staticClass: "col" }, [
              _c("span", { staticClass: "file-row__label" }, [
                _vm._v(" Fecha: ")
              ]),
              _c("br"),
              _c("span", [_vm._v(_vm._s(_vm._f("date")(_vm.createdDate)))])
            ])
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col d-flex align-items-end justify-content-end" },
          [
            !_vm.isShowingReplacement
              ? _c(
                  "div",
                  [
                    _c("action-button", {
                      staticClass: "action-button",
                      attrs: {
                        i: "action-icon fas fa-file-download",
                        variant: "success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("download")
                        }
                      }
                    }),
                    _vm.canReplace
                      ? _c("action-button", {
                          staticClass: "action-button",
                          attrs: {
                            i: "action-icon fas fa-undo",
                            variant: "outline-success"
                          },
                          on: {
                            click: function($event) {
                              _vm.isShowingReplacement = true
                            }
                          }
                        })
                      : _vm._e(),
                    _vm.canRemoveDocument
                      ? _c("action-button", {
                          attrs: {
                            id: "btn-remove-doc",
                            i: "fa fa-times-circle mr-n1 pr-1",
                            variant: "outline-danger ml-1"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit("remove")
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      ]),
      _vm.isShowingReplacement
        ? _c("DeterminationFileUpload", {
            attrs: {
              id: _vm.documentId,
              "evaluator-name": _vm.evaluatorName,
              name: _vm.documentName
            },
            on: {
              cancel: function($event) {
                _vm.isShowingReplacement = false
              },
              upload: _vm.replace
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }